export default "__VITE_ASSET__CoXO2qW___"